/* eslint-disable consistent-return */
import fetch from 'isomorphic-unfetch';

import config from '../../config';

const { apiHost } = config;
export const CLUBS_FETCH = 'CLUBS:FETCH';
export const CLUBS_FETCH_SUCCESS = 'CLUBS:FETCH_SUCCESS';
export const CLUBS_FETCH_FAILURE = 'CLUBS:FETCH_FAILURE';
export const CLUBS_ORGANIZER_FETCH = 'CLUBS:ORGANIZER_FETCH';
export const CLUBS_ORGANIZER_FETCH_SUCCESS = 'CLUBS:ORGANIZER_FETCH_SUCCESS';
export const CLUBS_ORGANIZER_FETCH_FAILURE = 'CLUBS:ORGANIZER_FETCH_FAILURE';
export const CLUBS_LATEST_EVENT_FETCH = 'CLUBS:LATEST_EVENT_FETCH';
export const CLUBS_LATEST_EVENT_FETCH_SUCCESS = 'CLUBS:LATEST_EVENT_FETCH_SUCCESS';
export const CLUBS_LATEST_EVENT_FETCH_FAILURE = 'CLUBS:LATEST_EVENT_FETCH_FAILURE';

export const fetchClubOrganizers = (tierTypeId, clubIds = []) => async (dispatch) => {
    dispatch({ type: CLUBS_ORGANIZER_FETCH, tierTypeId });
    try {
        return await fetch(`${apiHost}/v1/club/organizer/email`, {
            method: 'post',
            body: JSON.stringify({ clubIds, tierTypeId }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    dispatch({
                        type: CLUBS_ORGANIZER_FETCH_FAILURE,
                        tierTypeId,
                        data: data.error,
                    });
                } else {
                    dispatch({
                        type: CLUBS_ORGANIZER_FETCH_SUCCESS,
                        tierTypeId,
                        data,
                    });
                }
            });
    } catch (error) {
        dispatch({ type: CLUBS_ORGANIZER_FETCH_FAILURE, tierTypeId });
        console.log(`error fetch clubs organizer tierTypeId ${tierTypeId}`, error);
    }
};

export const fetchClubLatestEvents = (tierTypeId, clubIds = []) => async (dispatch) => {
    dispatch({ type: CLUBS_LATEST_EVENT_FETCH, tierTypeId });
    try {
        return await fetch(`${apiHost}/v2/search/events/latest`, {
            method: 'post',
            body: JSON.stringify({ clubIds }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    dispatch({
                        type: CLUBS_LATEST_EVENT_FETCH_FAILURE,
                        tierTypeId,
                        data: data.error,
                    });
                } else {
                    dispatch({
                        type: CLUBS_LATEST_EVENT_FETCH_SUCCESS,
                        tierTypeId,
                        data,
                    });
                }
            });
    } catch (error) {
        dispatch({ type: CLUBS_LATEST_EVENT_FETCH_FAILURE, tierTypeId });
        console.log(`error fetch clubs latest event tierTypeId ${tierTypeId}`, error);
    }
};

export const fetchClubs = ({ tierTypeId, lat, lng, distance }) => async (dispatch) => {
    dispatch({ type: CLUBS_FETCH, tierTypeId });
    try {
        const params = new URLSearchParams();
        if (distance && lat && lng) {
            params.append('distance', distance);
            params.append('pin', `${lat},${lng}`);
        }

        return await fetch(
            `${apiHost}/v2/search/clubs/${tierTypeId}?${params.toString()}`,
        )
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    dispatch({
                        type: CLUBS_FETCH_FAILURE,
                        tierTypeId,
                        data: data.error,
                    });
                } else {
                    dispatch({
                        type: CLUBS_FETCH_SUCCESS,
                        tierTypeId,
                        data,
                    });
                    if (data.hits.length > 0) {
                        const clubIds = data.hits.map(x => x.source.id);
                        dispatch(fetchClubOrganizers(tierTypeId, clubIds));
                        dispatch(fetchClubLatestEvents(tierTypeId, clubIds));
                    }
                }
            });
    } catch (error) {
        dispatch({ type: CLUBS_FETCH_FAILURE, tierTypeId });
        console.log(`error fetch clubs tierTypeId ${tierTypeId}`, error);
    }
};
